import { useEffect } from 'react';
import { useYfiCountries } from '@/hooks/useYfiCountries';

export function DatasetSchema() {
  // Fetch countries from database
  const { data: countries } = useYfiCountries();

  useEffect(() => {
    const existingScript = document.querySelector('script[data-schema="dataset"]');
    
    if (!existingScript && countries && countries.length > 0) {
      const countriesCount = countries.filter(c => 
        c.data_availability === 'Complete'
      ).length;

      const datasetSchema = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        "name": "Youth Futures Index (YFI) Global Rankings",
        "alternateName": "YFI Rankings",
        "description": "The Youth Futures Index (YFI) is a composite indicator measuring young people's potential to create sustainable impact across countries. It combines three dimensions: Mental Health & Well-being (40%), Workforce Readiness (30%), and Entrepreneurship & Innovation (30%).",
        "url": "https://jci.dashcity.app/impact-metrics",
        "identifier": "jci-yfi-2025",
        "keywords": [
          "Youth Futures Index",
          "YFI",
          "youth development",
          "mental health",
          "workforce readiness",
          "entrepreneurship",
          "global rankings",
          "JCI",
          "young leaders"
        ],
        "creator": {
          "@type": "Organization",
          "name": "Junior Chamber International",
          "url": "https://jci.cc"
        },
        "publisher": {
          "@type": "Organization",
          "name": "JCI Futures Observatory"
        },
        "datePublished": "2025-01-01",
        "dateModified": new Date().toISOString().split('T')[0],
        "temporalCoverage": "2025",
        "spatialCoverage": "Global",
        "license": "https://creativecommons.org/licenses/by-nc/4.0/",
        "isAccessibleForFree": true,
        "distribution": {
          "@type": "DataDownload",
          "encodingFormat": "text/csv",
          "contentUrl": "https://jci.dashcity.app/impact-metrics"
        },
        "variableMeasured": [
          {
            "@type": "PropertyValue",
            "name": "Mental Health Score",
            "description": "Measures youth mental health and well-being indicators",
            "unitText": "Index Score (0-100)",
            "minValue": 0,
            "maxValue": 100
          },
          {
            "@type": "PropertyValue",
            "name": "Workforce Score",
            "description": "Measures workforce readiness and employability of young people",
            "unitText": "Index Score (0-100)",
            "minValue": 0,
            "maxValue": 100
          },
          {
            "@type": "PropertyValue",
            "name": "Entrepreneurship Score",
            "description": "Measures entrepreneurial ecosystem and innovation capacity",
            "unitText": "Index Score (0-100)",
            "minValue": 0,
            "maxValue": 100
          },
          {
            "@type": "PropertyValue",
            "name": "YFI Score",
            "description": "Composite Youth Futures Index score",
            "unitText": "Index Score (0-100)",
            "minValue": 0,
            "maxValue": 100
          }
        ],
        "measurementTechnique": "Composite index calculation using weighted average: Mental Health (40%) + Workforce (30%) + Entrepreneurship (30%)",
        "includedInDataCatalog": {
          "@type": "DataCatalog",
          "name": "JCI Futures Observatory Data Repository"
        },
        "size": `${countriesCount} countries`
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'dataset');
      script.textContent = JSON.stringify(datasetSchema);
      document.head.appendChild(script);
    }
    
    return () => {
      const script = document.querySelector('script[data-schema="dataset"]');
      if (script) script.remove();
    };
  }, [countries]);

  return null;
}
